import React from 'react';
import { FaCamera } from 'react-icons/fa';
import { formatNum } from '../../../services/cadastral.service';
import styles from '../../../styles/Cadastral.module.css';

function Block({ title, icon: Icon, children }) {
  return (
    <div className={styles.block}>
      <div className={styles.blockTitle}>
        <span className={styles.btIco}><Icon size={13} /></span>
        {title}
      </div>
      {children}
    </div>
  );
}

export default function PhotosTab({ file }) {
  const hasConstructionRecords = file.buildings && file.buildings.length > 0;

  return (
    <div className={styles.tabContentFade}>
      <Block title="Verificación física y ortomosaico digital" icon={FaCamera}>
        <div className={styles.photos}>
          <figure className={styles.photo}>
            <img
              src="/assets/cadastral/building-facade.png"
              alt="Fotografía de fachada del inmueble"
              loading="lazy"
            />
            <figcaption>
              <strong>Verificación física</strong>
              Captura fotográfica de fachada obtenida durante la verificación del inmueble.
            </figcaption>
          </figure>

          <figure className={styles.photo}>
            <img
              src="/assets/cadastral/orthomosaic.png"
              alt="Ortomosaico digital con polígonos catastrales"
              loading="lazy"
            />
            <figcaption>
              <strong>Ortomosaico digital</strong>
              Determinación de polígonos de terreno y superficie de construcción por nivel.
            </figcaption>
          </figure>
        </div>

        <div className={styles.legend}>
          <span>
            <i style={{ borderColor: '#e879b9' }} /> Polígono de terreno registrado
          </span>
          <span>
            <i style={{ borderColor: '#22d3ee' }} /> Polígono de construcción detectada
          </span>
        </div>

        <div className={styles.stateDetail} style={{ marginTop: '14px' }}>
          Revisión realizada mediante ortomosaico digital, concatenado con los expedientes y registros que obran en los
          archivos de la Dirección de Catastro y corroborado con la verificación física y/o electrónica del inmueble.{' '}
          {hasConstructionRecords ? (
            <>
              Se determinaron <strong>{file.buildings.length} polígono(s)</strong> de construcción con una superficie total de{' '}
              <strong>{formatNum(file.totalBuildingArea)} m²</strong>.
            </>
          ) : (
            'No se detectaron polígonos de construcción en el predio.'
          )}
        </div>
      </Block>
    </div>
  );
}